// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8f50e183","787":"35047ba4","842":"0dc86eca"}[chunkId] + ".chunk.js";
};